module.exports = __webpack_public_path__ + "img/no-winner.b0275d47.png";